module.exports = __webpack_public_path__ + "static/partner5-5f4ca9b1da2e4604ae4f4571134f55ae.png";